const FJMotionUtil = {
    is3DAnimation: animationName => {
        const ANIMATION_3D_NAME = [
            'ALL_SPIN_3D_LOOP',
            'ALL_SPIN_3D_VERTICAL_LOOP',
            'ALL_SWAY_3D_LOOP',
            'ALL_SWAY_3D_VERTICAL_LOOP',
            'ALL_SPIN_SMOOTH_LOOP',
            'ALL_SPIN_3D_IN',
            'ALL_SPIN_3D_OUT',
        ];
        if (ANIMATION_3D_NAME.includes(animationName)) {
            return true;
        }
        return false;
    },

    /**
     * 从transform属性中删除指定的transform函数
     * @param {string} cssText - CSS文本
     * @param {string|Array} transformFunctions - 要删除的transform函数名，如'perspective', 'rotateX'等
     * @returns {string} 处理后的CSS文本
     */
    removeTransformFunctions: (cssText, transformFunctions) => {
        if (!cssText || !transformFunctions) return cssText;

        const functionsToRemove = Array.isArray(transformFunctions) ? transformFunctions : [transformFunctions];
        let result = cssText;

        functionsToRemove.forEach(func => {
            // 匹配transform属性中的指定函数
            const regex = new RegExp(`transform\\s*:\\s*([^;]*?)${func}\\([^)]+\\)\\s*([^;]*);?`, 'gi');
            result = result.replace(regex, (match, p1, p2) => {
                let newTransform = (p1 + (p2 ? ' ' + p2 : '')).replace(/\s+/g, ' ').trim();
                return newTransform ? `transform: ${newTransform};` : '';
            });
        });

        return result;
    },
};

export default FJMotionUtil;
